import script from "./esDataCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./esDataCard.vue?vue&type=script&setup=true&lang=ts"

import "./esDataCard.vue?vue&type=style&index=0&id=24fbd170&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24fbd170"]])

export default __exports__